export default {
  id: 'Header',
  code: 'CN',
  text: {
    'Upgrade to Paid Versions': '升级付费版',
    'Free': '免费版',
    'Premium': '高级版',
    'Change School': '切换学校',
    'School Information': '学校信息',
    'School Settings': '学校设置',
    'Create New School': '创建新学校',
    '$79 USD / month per school': '每学校每个月 $79 USD',
    'New': '新增',
    'Smart Check-in': '智能签到',
    'Students': '学员',
    'Teachers': '老师',
    'Classes': '班级',
    'Private Classes': '私课',
    'Classrooms': '教室',
    'Announcements': '公告',
    'Posters': '海报',
    'Contacts': '联系人',
    'Privacy Policy': '隐私政策',
    'Account Settings': '帐号设定',
    'Sign Out': '登出',
    "Free Trial ({daysLeft} days left)": '免费试用版还剩{daysLeft}天',
    'Upgrade': '升级',
    'Subscribe': '订阅升级',
    'Need Subscription': '需要订阅'
  }
}



// WEBPACK FOOTER //
// ./src/containers/Main/Header/locale.js